import React from "react";

function Privacy() {
    return (
        <div className="container-fluid privacy-content bg_img_privacy_term">
            {/* <h2 className="text-center text-dark mb-4">Privacy Policy</h2> */}

            {/* Scrollable Content Wrapper */}
            <div className="p-4 rounded text-content-privacy-term">
            <h2 className="text-center text-dark mb-4">Privacy Policy</h2>

                <p className="fw-bold">Last Updated: December 18, 2024</p>

                <p>
                    This Privacy Policy describes Our Policies and procedures on the
                    collection, use, and disclosure of Your information when You use the
                    Service and tells You about Your Privacy Rights and how the law
                    protects You.
                </p>

                <p>
                    We use Your personal data to provide and improve the Service. By
                    using the Service, You agree to the collection and use of information
                    in accordance with this Privacy Policy.
                </p>

                <h4 className="mt-4">Interpretation and Definitions</h4>
                <h5 className="mt-3">Interpretation</h5>
                <p>
                    The words of which the initial letter is capitalized have meanings
                    defined under the following conditions. The following definitions
                    shall have the same meaning regardless of whether they appear in
                    singular or in plural.
                </p>

                <h5 className="mt-3">Definitions</h5>
                <p>For the purposes of this Privacy Policy:</p>
                <ul className="list-unstyled ms-4">
                    <li>
                        <strong>Account</strong> means a unique account created for You to access our Service or parts of our Service
                    </li>
                    <li>
                        <strong>Application</strong> refers to CitriHub, the software program developed by ICAR-CCRI.
                    </li>
                    <li>
                        <strong>Institute</strong>  (referred to as either "the Institute", "We", "Us" or "Our" in this Policy) refers to ICAR-Central
                        Citrus Research Institute, Amravati Road, Nagpur 440033, Maharashtra, India.
                    </li>
                    <li>
                        <strong>Country</strong> refers to: India
                    </li>
                    <li>
                        <strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital
                        tablet.
                    </li>
                    <li>
                        <strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.
                        Service refers to the Application.
                    </li>
                    <li>
                        <strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the
                        Institute. It refers to third-party companies or individuals employed by the Institute to facilitate the
                        Service, to provide the Service on behalf of the Institute, to perform services related to the Service or
                        to assist the Institute in analyzing how the Service is used.
                    </li>
                    <li>
                        <strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from
                        the Service infrastructure itself (for example, the duration of a page visit).
                    </li>
                    <li>
                        <strong>You</strong> means the individual accessing or using the Service, or other organization, or other legal entity
                        on behalf of which such individual is accessing or using the Service, as applicable.

                    </li>

                </ul>
                <h4 className="mt-4">Collecting and Using Your Personal Data</h4>
                <h5 className="mt-3">Types of Data Collected</h5>
                <h5 className="mt-3">Personal Data</h5>
                <p>While applying to avail Our business incubation services, We will ask You to provide Us with certain
                    personally identifiable information that can be used to contact or identify You. Personally identifiable
                    information may include, but is not limited to:</p>
                <ul className="list-unstyled ms-4">
                    <li>Email address</li>
                    <li>First name and last name</li>
                    <li>Phone number</li>
                    <li>Address, State, Province, ZIP/Postal code, City</li>
                    <li>Usage Data</li>
                </ul>
                <h5 className="mt-3">Usage Data</h5>
                <p>Usage Data is collected automatically when using the Service.</p>
                <p>Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address),
                    browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the
                    time spent on those pages, unique device identifiers and other diagnostic data.</p>
                <p>When You access the Service by or through a mobile device, We may collect certain information
                    automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet
                    browser You use, unique device identifiers and other diagnostic data.
                    We may also collect information that Your browser sends whenever You visit our Service or when You
                    access the Service by or through a mobile device.
                </p>
                <h5 className="mt-3">Use of Your Personal Data</h5>
                <p>The Institute may use Personal Data for the following purposes:</p>
                <ul className="list-unstyled ms-4">

                    <li><strong>To provide and maintain our Service,</strong>including to monitor the usage of our Service.</li>
                    <li><strong>For the performance of an agreement:</strong>the development, compliance and undertaking of the
                        agreement for the business incubation services You have availed or of any other contract with Us
                        through the Service.
                    </li>
                    <li><strong>To contact You: </strong>To contact You by email, telephone calls, SMS, or other equivalent forms of
                        electronic communication, such as a mobile application's push notifications regarding updates or
                        informative communications related to the functionalities, products or contracted services,
                        including the security updates, when necessary or reasonable for their implementation.</li>
                    <li><strong>To provide You</strong>with news, special offers and general information about other goods, services and
                        events which we offer that are similar to those that you have already purchased or enquired about
                        unless You have opted not to receive such information.
                    </li>
                    <li><strong>To manage Your requests:</strong>To attend and manage Your requests to Us.</li>
                    <li><strong>For other purposes: </strong>We may use Your information for other purposes, such as data analysis,
                        identifying usage trends, determining the effectiveness of our promotional campaigns and to
                        evaluate and improve our Service, products, services, marketing and your experience.</li>
                    <li>We may use Your information for other purposes, such as data analysis,
                        identifying usage trends, determining the effectiveness of our promotional campaigns and to
                        evaluate and improve our Service, products, services, marketing and your experience.</li>

                </ul>

                <p className="mt-0">We may share Your personal information in the following situations:</p>

                <ul>
                    <li> <strong>With Service Providers:</strong> We may share Your personal information with Service Providers to monitor
                        and analyze the use of our Service, to contact You.</li>
                    <li> <strong>With Your consent:</strong> We may disclose Your personal information for any other purpose with Your
                        consent.</li>

                </ul>
                <h5 className="mt-3">Retention of Your Personal Data</h5>
                <p>The Institute will retain Your Personal Data only for as long as is necessary for the purposes set out in this
                    Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal
                    obligations (for example, if we are required to retain your data to comply with applicable laws), resolve
                    disputes, and enforce our legal agreements and policies.</p>
                <p>The Institute will also retain Usage Data for internal analysis purposes. Usage Data is generally retained
                    for a shorter period of time, except when this data is used to strengthen the security or to improve the
                    functionality of Our Service, or We are legally obligated to retain this data for longer time periods.
                </p>
                <h5 className="mt-3">Transfer of Your Personal Data</h5>
                <p>
                    Your information, including Personal Data, is processed at the Institute's operating offices and in any
                    other places where the parties involved in the processing are located. It means that this information may
                    be transferred to and maintained on computers located outside of Your state or other governmental
                    jurisdiction.
                </p>
                <p>
                    Your consent to this Privacy Policy followed by Your submission of such information represents Your
                    agreement to that transfer.
                </p>
                <p>
                    The Institute will take all steps reasonably necessary to ensure that Your data is treated securely and in
                    accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an
                    organization or a country.
                </p>
                <h5 className="mt-3">Delete Your Personal Data</h5>
                <p>
                    You have the right to request that We assist in deleting the Personal Data that We have collected about
                    You.
                </p>
                <p>
                    You may request to update, amend, or delete Your information at any time.
                </p>
                <p>
                    Please note, however, that We may need to retain certain information when we have a legal obligation or
                    lawful basis to do so.
                </p>
                <h5 className="mt-3">Disclosure of Your Personal Data
                </h5>
                <p><strong>We do not sell, trade, or share</strong> your Personal Data with third parties, except as required by law or to
                    fulfill administrative compliance obligations.</p>
                <h5 className="mt-3"><i>Data Sharing with ICAR Headquarters</i></h5>
                <p>Your Personal Data may be shared with ICAR Headquarters located in New Delhi upon their request for
                    administrative, research, or policy-making purposes. Such sharing will be conducted in accordance with
                    applicable laws and regulations to ensure the protection of Your Personal Data.
                </p>
                <h5 className="mt-3"><i>Institutional Mergers</i></h5>
                <p>If the Institute is involved in a merger with other institute(s), Your Personal Data may be transferred. We
                    will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy
                    Policy.</p>
                <h5 className="mt-3"><i>Law enforcement</i></h5>
                <p>Under certain circumstances, the Institute may be required to disclose Your Personal Data if required to
                    do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).</p>
                <h5 className="mt-3"><i>Other legal requirements
                </i></h5>
                <p>The Institute may disclose Your Personal Data in the good faith belief that such action is necessary to:</p>
                <ul>
                    <li>Comply with a legal obligation</li>
                    <li>Protect and defend the rights or property of the Institute</li>
                    <li>Prevent or investigate possible wrongdoing in connection with the Service</li>
                    <li>Protect the personal safety of Users of the Service or the public</li>
                    <li>Protect against legal liability</li>
                </ul>
                <h5 className="mt-3">Security of Your Personal Data</h5>
                <p>The security of Your Personal Data is important to Us, but remember that no method of transmission over
                    the Internet, or method of electronic storage is 100% secure. While We strive to use commercially
                    acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.
                </p>
                <h5 className="mt-3">Children's Privacy</h5>
                <p>Our Service does not address anyone under the age of 18. We do not knowingly collect personally
                    identifiable information from anyone under the age of 18. If You are a parent or guardian and You are
                    aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that
                    We have collected Personal Data from anyone under the age of 18 without verification of parental
                    consent, We take steps to remove that information from Our servers.</p>
                <h5 className="mt-3">Links to Other Websites</h5>
                <p>Our Service may contain links to other websites that are not operated by Us. If You click on a third-party
                    link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of
                    every site You visit.</p>
                <p>We have no control over and assume no responsibility for the content, privacy policies or practices of any
                    third-party sites or services.</p>
                <h5 className="mt-3">Cookies and Tracking Technologies
                </h5>
                <p>Our Service may use cookies or similar technologies to enhance your experience. You can disable these
                    features through your device settings.</p>
                <h5 className="mt-3">Changes to this Privacy Policy
                </h5>
                <p>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the
                    new Privacy Policy on this page.</p>
                <p>We will let You know via a prominent notice on Our Service, prior to the change becoming effective and
                    update the "Last updated" date at the top of this Privacy Policy.</p>
                <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy
                    are effective when they are posted on this page.</p>
                <h5 className="mt-3">Contact Us </h5>
                <p>If you have any questions about this Privacy Policy, you can contact us by email: <a href="mailto:ccrinaif@gmail.com">ccrinaif@gmail.com</a></p>
            </div>
        </div>
    );
}

export default Privacy;
